import { useTheme } from 'next-themes';
import { useSession } from '@/contexts/LitSessionProvider';
import useGetLocation from '@/hooks/utilities/useGetLocation';
var onramperPaymentMethods = {
    apple: 'applepay',
    google: 'googlepay',
    card: 'creditcard',
    bank: 'banktransfer',
};
export default function OnramperUrl(_a) {
    var amount = _a.amount, paymentMethod = _a.paymentMethod;
    var PKP = useSession().PKP;
    var theme = useTheme().theme;
    var _b = onramperColors(theme), containerColor = _b.containerColor, cardColor = _b.cardColor, secondaryColor = _b.secondaryColor, primaryColor = _b.primaryColor;
    var _c = useGetLocation(), geoCountry = _c.geoCountry, geoState = _c.geoState;
    var url = "https://buy.onramper.com?apiKey=pk_prod_01J09Q61JSG3A6THMBRVHGD9FH&mode=buy&themeName=".concat(theme === 'dark' ? 'dark' : 'light', "&containerColor=").concat(containerColor, "&borderRadius=0.5&wgBorderRadius=1&cardColor=").concat(cardColor, "&secondaryColor=").concat(secondaryColor, "&primaryColor=").concat(primaryColor, "&wallets=sol:").concat(PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress, "&successRedirectUrl=www.tradegenius.com%2Fhome%3Fmessage%3D'Your%20deposit%20was%20a%20success.%20Please%20allow%20up%20to%205%20minutes%20for%20your%20account%20to%20reflect%20the%20deposit.'&failureRedirectUrl=www.tradegenius.com%2Fhome%3Fmessage%3D'Your%20deposit%20failed.%20Please%20try%20again%20or%20contact%20support.'&mode=buy&defaultCrypto=sol&defaultFiat=usd&defaultAmount=").concat(amount, "&defaultPaymentMethod=").concat(onramperPaymentMethods[paymentMethod]) + (geoState == 'NY' ? '&onlyOnramps=stripe' : '&supportRecurringPayments=true');
    return { url: url };
}
export var onramperColors = function (theme) {
    var containerColor = theme === 'dark' ? '231645' : 'FAF5FF';
    var cardColor = theme === 'dark' ? '09001A' : 'E6DBFF';
    var secondaryColor = theme === 'dark' ? '231645' : 'FAF5FF';
    var primaryColor = 'FF578F';
    return { containerColor: containerColor, cardColor: cardColor, secondaryColor: secondaryColor, primaryColor: primaryColor };
};
